import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'

export type AlertType = 'warning' | 'critical'

export interface AlertData {
  type?: AlertType
  icon?: string
  message?: string
  title?: string
}

@Component({
    selector: 'lib-critical-alert',
    templateUrl: './critical-alert.component.html',
    styleUrls: ['./critical-alert.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CriticalAlertComponent {
  private dialogRef = inject(MatDialogRef<CriticalAlertComponent>)
  private _data = inject<AlertData>(MAT_DIALOG_DATA, { optional: true }) || {}

  private readonly defaultData: Required<Pick<AlertData, 'type' | 'message' | 'icon'>> = {
    type: 'warning',
    message: 'Você tem certeza de que deseja realizar esta ação?',
    icon: 'warning',
  }

  public effectiveData = { ...this.defaultData, ...this._data }

  public iconClass = this.getColorClass('icon')
  public buttonClass = this.getColorClass('button')
  public titleClass = this.getColorClass('title')

  onNoClick(): void {
    this.dialogRef.close()
  }

  private getColorClass(context: 'icon' | 'button' | 'title'): string {
    const isCritical = this.effectiveData.type === 'critical'
    const colors = {
      icon: isCritical ? 'text-red-600' : 'text-yellow-500',
      button: isCritical
        ? 'bg-red-600 text-white hover:bg-red-700'
        : 'bg-yellow-500 text-white hover:bg-yellow-600',
      title: isCritical
        ? 'text-red-600 font-bold'
        : 'text-yellow-500 font-bold',
    }
    return colors[context]
  }
}
